import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { resolveCode } from "../../lib/resolveCode";

/**
 * Deep-Link-Landing: `/scan/handle?raw=...` oder
 * `/scan/handle?kind=...&id=...`.
 *
 * Aktivierbar via:
 *   - PWA `protocol_handlers` für `web+platzwart://...`
 *   - Direktlink z.B. aus Email / Chat
 *   - QR-Code auf dem Sticker (wenn System-Kamera das Protokoll unterstützt)
 *
 * Verhalten: Resolve Code -> beste Quick-Action via sessionStorage-Prefill
 * -> Redirect. Wenn nichts auflöst: zeige Fehler + zurück auf /scan.
 */
export default function ScanDeepLink() {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    useEffect(() => {
        let raw = params.get("raw");
        const kind = params.get("kind");
        const id = params.get("id");
        if (!raw && kind && id) raw = `platzwart://${kind}/${id}`;
        // `web+platzwart:compartment/abc` kommt als Protokoll-Handler ggf.
        // mit Prefix -- wir normalisieren:
        if (raw && raw.startsWith("web+platzwart:")) {
            raw = raw.replace(/^web\+platzwart:\/*/, "platzwart://");
        }
        if (!raw) {
            navigate("/scan", { replace: true });
            return;
        }
        (async () => {
            const r = await resolveCode(raw);
            if (!r.ok) {
                toast.error(r.error);
                navigate("/scan", { replace: true });
                return;
            }
            const best = r.suggestedFlows?.[0];
            if (best) {
                if (best.prefill) {
                    sessionStorage.setItem("pw:scan-prefill", JSON.stringify(best.prefill));
                }
                toast.success(`${r.label} -> ${best.label}`);
                navigate(best.to, { replace: true });
            } else {
                navigate("/scan", { replace: true });
            }
        })();
    }, [params, navigate]);

    return (
        <div className="flex min-h-[40vh] items-center justify-center text-xs text-muted-foreground" data-testid="scan-deeplink">
            Code wird aufgelöst...
        </div>
    );
}
